export default __webpack_public_path__ + "static/media/center-light.ac56d420.png";